import { throwErrorForDev } from '@zocdoc-frontend-common/utils-react';

/**
 * Returns true if the node env is production.
 */
export const isProductionBuild = () =>
    process.env.NODE_ENV?.trim() === 'production';

/**
 * Returns true if the string is null, undefined or whitespace.
 * @param {string} theString - string to check
 */
export const isNullOrEmptyString = (theString) => !theString?.trim()?.length;

/**
 * Throws an error if the function passed in is undefined or not a function.
 * @param {function} theFunction - function to check
 * @param {string} errorMessage - Error message inside the thrown error.
 */
export const throwIfNotFunction = (theFunction, errorMessage) => {
    if (typeof theFunction !== 'function') {
        throwErrorForDev(errorMessage);
    }
};

/**
 * Throws an error if all of the strings are null, undefined or whitespace.
 * @param {Array} thestrings - array of strings to check. Must be an array.
 * @param {string} errorMessage - Error message inside the thrown error.
 */
export const throwIfAllNullOrEmptyStrings = (thestrings, errorMessage) => {
    if (thestrings.every((theString) => isNullOrEmptyString(theString))) {
        throwErrorForDev(errorMessage);
    }
};

/**
 * Throws an error if the string is null, undefined or whitespace.
 * @param {string} theString - string to check
 * @param {string} errorMessage - Error message inside the thrown error.
 */
export const throwIfNullOrEmptyString = (thestring, errorMessage) => {
    throwIfAllNullOrEmptyStrings([thestring], errorMessage);
};

/**
 * Throws an error if the boolean passed in is undefined or not an object.
 * @param {string} theBoolean - boolean to check
 * @param {string} errorMessage - Error message inside the thrown error.
 */
export const throwIfNotBoolean = (theBoolean, errorMessage) => {
    if (typeof theBoolean !== 'boolean') {
        throwErrorForDev(errorMessage);
    }
};

/**
 * Throws an error if the object passed in is undefined or not an object.
 * @param {string} theObject - object to check
 * @param {string} errorMessage - Error message inside the thrown error.
 */
export const throwIfNotObject = (theObject, errorMessage) => {
    // JS treats null as an object
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/typeof#typeof_null
    if (theObject === null || typeof theObject !== 'object') {
        throwErrorForDev(errorMessage);
    }
};

/**
 * Throws an error if the array passed in is not an array or it is undefined or empty.
 * @param {string} theArray - array to check
 * @param {string} errorMessage - Error message inside the thrown error.
 */
export const throwIfNullOrEmptyArray = (theArray, errorMessage) => {
    if (!Array.isArray(theArray) || !theArray?.length) {
        throwErrorForDev(errorMessage);
    }
};
